import { Card, Col, Row } from "antd";
import Calendar from "./Calendar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import modifyId from "../../utils/modifyId";
import axiosClient from "../../api/axiosClient";
import handleApiError from "../../utils/handleError";
import prepareSlots from "../../utils/prepareSlots";

export interface ISlot {
  time: number;
  count: number;
}

export default function RescheduleExamSlot() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [slots, setSlots] = useState<ISlot[]>([]);
  const [datesAndSlots, setDatesAndSlots] = useState<any>({});

  const exam_instance_id = params.id;
  const scheduleDate = location.state?.scheduleDate;

  async function handleSelect(selectedDate: any) {
    if (slots?.length) {
      navigate(`/schedule-session/reschedule-available-slots/${params.id}`, {
        state: {
          slots: slots,
          selectedDate: selectedDate,
          scheduleDate,
          voucherDetails,
        },
      });
    }
  }

  const [voucherDetails, setVoucherDetails] = useState<any>({});

  useEffect(() => {
    async function getVoucherDetails() {
      try {
        let res = await axiosClient.get(
          `examinstances/${exam_instance_id}/slots`
        );
        setSlots(res.data);
        res = await axiosClient.get(`examinstances/${exam_instance_id}/user`);
        setVoucherDetails(res.data);
      } catch (error: any) {
        navigate(-1);
        handleApiError(error);
      }
    }
    getVoucherDetails();
    // eslint-disable-next-line
  }, [exam_instance_id]);

  useEffect(() => {
    setDatesAndSlots(prepareSlots(slots));
  }, [slots, setDatesAndSlots]);

  return (
    <div className="book_slot_container">
      <h5>Book Your Exam Slot</h5>
      <Card bordered={false}>
        <h5>
          1. Choose a Slot: Select a time that suits your schedule from the
          available options.
        </h5>
        <h5>
          2. Verify Slot: Double-check the chosen time to ensure it's correct
          before finalizing your booking.
        </h5>
      </Card>

      <Row
        style={{ marginTop: 30 }}
        justify="center"
        align="middle"
        gutter={[20, 20]}
      >
        <Col span={8} md={24} xl={8} lg={16}>
          <Calendar
            handleSelect={handleSelect}
            datesWithSlots={datesAndSlots}
            scheduleDate={scheduleDate}
          />
        </Col>
        <Col>
          <Row justify={"center"} gutter={[20, 20]} style={{ marginTop: 30 }}>
            <Col span={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-available"></div>
                    <span>Available Dates</span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-today"></div>
                    <span>Today's Date</span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-schedule"></div>
                    <span>Scheduled Date</span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="book_slot_guid_container">
                    <div className="book_slot_guide guide-unavailable"></div>
                    <span>Unavailable Dates</span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Card
            title="Exam Detail"
            style={{ marginTop: 20 }}
            bordered={false}
          >
            <table className="book_slot_exam_details">
              <tbody>
                <tr>
                  <td>Exam ID</td>
                  <td>{modifyId(voucherDetails?.exam?.id)}</td>
                </tr>
                <tr>
                  <td>Exam Name</td>
                  <td>{voucherDetails?.exam?.name}</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>{voucherDetails?.exam?.duration} minutes</td>
                </tr>
              </tbody>
            </table>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
